import React from 'react'
import AddEducation from './AddEducation/AddEducation'
import EducationInfo from './EducationInfo/EducationInfo'
import { Route, Routes } from 'react-router-dom'
import Education from './Education/Education'
const ProfileEducation = (props) => {
    return (
        <div className="mt-6 sm:mx-2 md:mx-6">
            <div>
                <Routes>
                    <Route path='/' element={<EducationInfo id={props.user.User?.id} />} />
                    <Route path='add' element={<AddEducation id={props.user.User?.id} />} />
                    <Route path=':id' element={<Education user={props.user} />} />
                </Routes>
            </div>
        </div>
    )
}

export default ProfileEducation
